module.exports = __webpack_public_path__ + "static/media/available.8f543dee.svg";